





























import { AuthMixin } from '@/components/authMixin'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { USER_GROUPS, USER_NAME } from '../service/constant'

@Component
export default class TopMenu extends Mixins(AuthMixin) {
  private trigger = ['click']
  private get username() {
    return this.$store.state[USER_NAME] || '未登录'
  }

  private get showMyInfo() {
    const groups = this.$store.state[USER_GROUPS]
    return groups && groups.length > 0
  }
}
